<template>
    <header class="header-global">
        <base-nav type="success" class="navbar-main" transparent effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <strong>DOMAINS CHECKUP</strong>
            </router-link>
            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="/">
                        <strong>DOMAINS CHECKUP</strong>
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>
            <ul class="navbar-nav ml-lg-auto" slot-scope="{closeMenu}">
                <li class="nav-item">
                    <router-link
                        slot="brand"
                        class="nav-link nav-link-icon"
                        to="/domains">
                        <base-button
                            @click="closeMenu"
                            size="sm"
                            type="default">DOMAINS</base-button>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link
                        slot="brand"
                        class="nav-link nav-link-icon"
                        to="/subscribers">
                        <base-button
                            @click="closeMenu"
                            size="sm"
                            type="default">SUBSCRIBERS</base-button>
                    </router-link>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
